'use client';

import { Modal, type ModalProps } from './Modal';
import { Box, Button, Typography } from '@mui/material';
import { Trans } from 'react-i18next';
import { Text } from '../Text';
import { createRef, useState } from 'react';

type TermsAndConditionProps = ModalProps & {
	text: string;
	textKey: 'termsAndConditions' | 'privacyNotice' | 'cookieNotice' | 'extraTermsContent';
	withButton: boolean;
	handleButtonClick?: () => void;
};

function yieldToMain() {
	return new Promise((resolve) => setTimeout(resolve, 0));
}

export const TermsAndConditions = ({ text, withButton, handleButtonClick, ...rest }: TermsAndConditionProps) => {
	const [scrolledToBottom, setScrolledToBottom] = useState(true);
	const modalRef = createRef<HTMLDivElement>();

	const setScrolledToBottomState = ({ scrollTop, scrollHeight, offsetHeight }: HTMLDivElement) => {
		// Add 50px of margin to action the scrolledToBottom
		setScrolledToBottom(50 + scrollTop >= scrollHeight - offsetHeight);
	};

	const callbackRef = () => {
		// Wait blocking tasks to complete before checking the scroll position
		yieldToMain().then(() => modalRef.current && setScrolledToBottomState(modalRef.current));
	};

	return (
		<Modal
			{...rest}
			modalRef={modalRef}
			callbackRef={callbackRef}
			handleScroll={(event) => setScrolledToBottomState(event.currentTarget)}
		>
			<Text disableColorDetection text={text} />
			{withButton && (
				<Box
					width="100%"
					textAlign="center"
					p={3}
					position="sticky"
					bgcolor="white"
					paddingBottom="64px"
					bottom="-40px"
					marginBottom="-40px"
				>
					<Button
						variant="contained"
						color="primary"
						size="large"
						onClick={handleButtonClick}
						disabled={!scrolledToBottom}
					>
						<Typography color="textSecondary" style={{ fontWeight: 900 }}>
							<Trans i18nKey="termsButton" />
						</Typography>
					</Button>
				</Box>
			)}
		</Modal>
	);
};
